import React from 'react';
export const Banner01DataSource = {
  wrapper: { className: 'banner0 kl3izkvi87-editor_css' },
  textWrapper: { className: 'banner0-text-wrapper' },
  title: {
    className: 'banner0-title kl3iza7r2c-editor_css',
    children:
      'https://xhm-test.oss-cn-beijing.aliyuncs.com/xhm_img/web/xhm_logo.png',
  },
  content: {
    className: 'banner0-content kl3j1fyxk8-editor_css',
    children: (
      <span>
        <p>合抱之木，生于毫末——《老子》</p>
      </span>
    ),
  },
  button: {
    className: 'banner0-button kl3j2ks2gc7-editor_css',
    children: 'Learn More',
  },
};
export const Feature40DataSource = {
  wrapper: { className: 'home-page-wrapper content6-wrapper' },
  OverPack: { className: 'home-page content6' },
  textWrapper: { className: 'content6-text', xs: 24, md: 10 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>小合木存在的意义</p>
          </span>
        ),
        className: 'title-h1',
      },
      {
        name: 'content',
        className: 'title-content',
        children: (
          <span>
            <p>这是我们从诞生之日起就一直秉持的原则</p>
          </span>
        ),
      },
    ],
  },
  img: {
    children: 'https://zos.alipayobjects.com/rmsportal/VHGOVdYyBwuyqCx.png',
    className: 'content6-img',
    xs: 24,
    md: 14,
  },
  block: {
    children: [
      {
        name: 'block0',
        img: {
          children:
            'https://zos.alipayobjects.com/rmsportal/NKBELAOuuKbofDD.png',
          className: 'content6-icon',
        },
        title: {
          className: 'content6-title',
          children: (
            <span>
              <p>帮用户真正解决问题</p>
            </span>
          ),
        },
        content: {
          className: 'content6-content',
          children: (
            <span>
              <p>
                技术的开放性是随着实际问题的解决而逐渐演化形成的，小合木从一开始就秉持着帮用户真正的解决问题，不让技术成为空中楼阁。
              </p>
            </span>
          ),
        },
      },
      {
        name: 'block1',
        img: {
          className: 'content6-icon',
          children:
            'https://zos.alipayobjects.com/rmsportal/xMSBjgxBhKfyMWX.png',
        },
        title: {
          className: 'content6-title',
          children: (
            <span>
              <p>融合</p>
            </span>
          ),
        },
        content: {
          className: 'content6-content',
          children: (
            <span>
              <p>
                与客户不再是甲乙方的关系，独创的合伙人机制使得小合木与我们的客户进行完美的融合，共同发展，客户的增长需求是我们唯一的盈利目标
              </p>
            </span>
          ),
        },
      },
      {
        name: 'block2',
        img: {
          className: 'content6-icon',
          children:
            'https://zos.alipayobjects.com/rmsportal/MNdlBNhmDBLuzqp.png',
        },
        title: {
          className: 'content6-title',
          children: (
            <span>
              <p>完美的售后标准</p>
            </span>
          ),
        },
        content: {
          className: 'content6-content',
          children: (
            <span>
              <p>
                依赖于合伙人模式，小合木打破了开发市场中交付完成之后的售后难，维护效果差的痛点问题，与我们的客户共同成长
              </p>
            </span>
          ),
        },
      },
    ],
  },
};
export const Teams00DataSource = {
  wrapper: { className: 'home-page-wrapper teams0-wrapper' },
  OverPack: { playScale: 0.3, className: 'home-page teams0' },
  BannerAnim: {
    className: 'banner-anim',
    children: [
      {
        name: 'elem0',
        className: 'teams0-banner-user-elem',
        titleWrapper: {
          className: 'teams0-content-wrapper',
          children: [
            {
              name: 'image',
              children:
                'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*njqxS5Ky7CQAAAAAAAAAAABjARQnAQ',
              className: 'teams0-image',
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>
                    互联网是开放性的，我们要让每一位用户，每一个商家，每一个企业，都能享受互联网的便利，体验互联网的美好。
                  </p>
                </span>
              ),
              className: 'teams0-content',
            },
            {
              name: 'title',
              children: (
                <span>
                  <p>刘友杰</p>
                </span>
              ),
              className: 'teams0-h1',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <p>小合木CEO</p>
                  </span>
                </span>
              ),
              className: 'teams0-content',
            },
          ],
        },
      },
    ],
  },
};
